import styled from 'styled-components';
import {copytext} from "../../../styles/typography.js";
import media from "../../../utilities/media.js";

const CheckboxContentStyled = styled.div`
  flex: 1 1 auto;

  ${media.moreThan("lg")} {
    width: 100%;
  }
`

const FakeCheckbox = styled.div`
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;

  background-color: ${props => props.theme.colors.buttonBackground};

  &:before, &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 10px;
    height: 20px;
    border-right: 1px solid ${props => props.theme.colors.buttonText};
    transform-origin: center right;
    transform: rotate(45deg);
    display: none;
  }

  &:after {
    transform: rotate(-45deg);
  }
`;

const CheckboxStyled = styled.input`
  display: none;

  &:checked + label ${FakeCheckbox} {
    &:before, &:after {
      display: block;
    }
  }
`;

const LabelStyled = styled.label`
  display: block;
  padding-left: 30px;
  position: relative;
  ${copytext};
  cursor: pointer;

  p {
    margin-bottom: 0;
  }

`;

const Checkbox = ({ name, label, checked, onChange }) => {
  return <CheckboxContentStyled>
    <CheckboxStyled type="checkbox" name={name} id={name} value={1} checked={checked} onChange={onChange}/>
    <LabelStyled htmlFor={name}>
      <FakeCheckbox/>
      <span dangerouslySetInnerHTML={{__html: label}}/>
    </LabelStyled>
  </CheckboxContentStyled>
}

export default Checkbox;
